import { DenunciaProvider } from '$providers/denuncia';
import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { DenunciaFormPage } from '../denuncia-form/denuncia-form';
import { DenunciaViewPage } from '../denuncia-view/denuncia-view';

@Component({
  selector: 'page-denuncia-list',
  templateUrl: 'denuncia-list.html',
})
export class DenunciaListPage {

  denuncias: Array<any> = [];
  constructor(public navCtrl: NavController, public navParams: NavParams, private denunciaProvider: DenunciaProvider) {
  }

  ionViewDidLoad() {
    this.denunciaProvider.loadItems().subscribe(
      (dados) => this.denuncias = dados,
      (err) => console.error(err)
    );
  }

  adicionar() {
    this.navCtrl.push(DenunciaFormPage);
  }

  selecionarDenuncia(denuncia) {
    this.navCtrl.push(DenunciaViewPage, { denuncia: denuncia });
  }
}



// WEBPACK FOOTER //
// ./src/pages/denuncia/denuncia-list/denuncia-list.ts